import { Command } from "commander";

import { commandChangelog } from "../usecases/changelog.js";
import { commandDoctor } from "../usecases/doctor.js";
import { commandUpdate } from "../usecases/update.js";
import { describeArguments, dispatch, type RunState } from "./registry.js";

export function registerToolCommands(program: Command, state: RunState): void {
  program.command("doctor")
    .description("Check configuration and runtime dependencies")
    .option("--llm-config <path>", "LLM configuration file")
    .action(dispatch(commandDoctor, state));

  program.command("update")
    .description("Update scriptctl to the latest release")
    .option("-n, --dry-run", "Show the update without installing")
    .option("--patch", "Allow a patch-level update")
    .action(dispatch(commandUpdate, state));

  const changelog = program.command("changelog [version]")
    .description("Show release notes")
    .option("--from <version>", "Start version")
    .option("--to <version>", "End version")
    .option("--unreleased", "Show unreleased changes")
    .action(dispatch(commandChangelog, state));
  describeArguments(changelog, ["Release version"]);
}
